var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4901 6.05269C14.305 5.93165 14.0865 5.86696 13.8629 5.86696C13.6394 5.86696 13.4209 5.93165 13.2358 6.05269L11.2862 7.21893C11.2668 7.22742 11.2458 7.23181 11.2245 7.23181C11.2032 7.23181 11.1822 7.22742 11.1628 7.21893C11.1194 7.20762 11.0822 7.18069 11.0588 7.14369L8.97923 3.53209C8.87815 3.36979 8.73525 3.23548 8.56443 3.14224C8.39362 3.049 8.2007 3 8.00444 3C7.80819 3 7.61527 3.049 7.44445 3.14224C7.27364 3.23548 7.13074 3.36979 7.02965 3.53209L4.87211 7.13742C4.84871 7.17442 4.8115 7.20135 4.76813 7.21266C4.74874 7.22115 4.72769 7.22554 4.70639 7.22554C4.6851 7.22554 4.66405 7.22115 4.64466 7.21266L2.72757 6.02761C2.54197 5.91427 2.32588 5.85621 2.10628 5.86067C1.88669 5.86513 1.67332 5.93192 1.49283 6.05269C1.30759 6.1748 1.1642 6.34733 1.08088 6.5483C0.997556 6.74928 0.978081 6.96963 1.02493 7.18131L2.1167 12.1285C2.17033 12.3746 2.30999 12.5955 2.51229 12.7542C2.71459 12.9128 2.96725 12.9996 3.22796 13H12.7744C13.0351 12.9996 13.2878 12.9128 13.4901 12.7542C13.6924 12.5955 13.8321 12.3746 13.8857 12.1285L14.9775 7.18131C15.0223 6.96774 14.9999 6.74609 14.913 6.54493C14.8261 6.34378 14.6788 6.17233 14.4901 6.05269Z",
    fill: "url(#paint0_linear_14_4143)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_14_4143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4901 7.05269C15.305 6.93165 15.0865 6.86696 14.8629 6.86696C14.6394 6.86696 14.4209 6.93165 14.2358 7.05269L12.2862 8.21893C12.2668 8.22742 12.2458 8.23181 12.2245 8.23181C12.2032 8.23181 12.1822 8.22742 12.1628 8.21893C12.1194 8.20762 12.0822 8.18069 12.0588 8.14369L9.97923 4.53209C9.87815 4.36979 9.73525 4.23548 9.56443 4.14224C9.39362 4.049 9.2007 4 9.00444 4C8.80819 4 8.61527 4.049 8.44445 4.14224C8.27364 4.23548 8.13074 4.36979 8.02965 4.53209L5.87211 8.13742C5.84871 8.17442 5.8115 8.20135 5.76813 8.21266C5.74874 8.22115 5.72769 8.22554 5.70639 8.22554C5.6851 8.22554 5.66405 8.22115 5.64466 8.21266L3.72757 7.02761C3.54197 6.91427 3.32588 6.85621 3.10628 6.86067C2.88669 6.86513 2.67332 6.93192 2.49283 7.05269C2.30759 7.1748 2.1642 7.34733 2.08088 7.5483C1.99756 7.74928 1.97808 7.96963 2.02493 8.18131L3.1167 13.1285C3.17033 13.3746 3.30999 13.5955 3.51229 13.7542C3.71459 13.9128 3.96725 13.9996 4.22796 14H13.7744C14.0351 13.9996 14.2878 13.9128 14.4901 13.7542C14.6924 13.5955 14.8321 13.3746 14.8857 13.1285L15.9775 8.18131C16.0223 7.96774 15.9999 7.74609 15.913 7.54493C15.8261 7.34378 15.6788 7.17233 15.4901 7.05269Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_14_4143",
    x: 0.1,
    y: 2.1,
    width: 17.8,
    height: 13.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14_4143"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14_4143",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_4143",
    x1: 8,
    y1: 3,
    x2: 8,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BA865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE4CA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.da48d3d44b22bd9c6fc4f0bf297093df.svg";
export { ForwardRef as ReactComponent };